import { RsHTMLElement } from '../rs-htmlelement.js';
import styles from 'inline:./rs-search-box.scss';
import textareaStyles from 'inline:./rs-search-box-textarea.scss';

export class RsSearchBox extends RsHTMLElement {
    hideOnNoResults = false;

    styles() {
        return styles;
    }

    async mounted() { 
        await this.waitForAtomicSearchBox();

        this.injectAtomicStyleSheets();
        await this.moveToSelector();
        this.initEvents();
    }

    get atomicSearchBox() {
        return this.shadow.querySelector('atomic-search-box');
    }

    get atomicSuggestionsBox() {
        return this.atomicSearchBox.shadowRoot.querySelector('[part~="suggestions-wrapper"]');
    }

    get searchBox() {
        return this.shadow.querySelector('.search-box');
    }

    get selectorToMoveTo() {
        return this.getAttribute('move-to-selector');
    }

    injectAtomicStyleSheets() {
        this.addStyles(textareaStyles, this.atomicSearchBox.shadowRoot);
    }

    async moveToSelector() {
        if (!this.selectorToMoveTo) {
            return;
        }

        const targetElement = document.querySelector(this.selectorToMoveTo);

        if (!targetElement) {
            console.info(`Could not move search box to specified ${this.selectorToMoveTo} selector`);
            return;
        }

        await customElements.whenDefined('atomic-external');

        const atomicExternal = document.createElement('atomic-external');
        atomicExternal.appendChild(this);

        targetElement.replaceWith(atomicExternal);
    }

    async waitForAtomicSearchBox() {
        await customElements.whenDefined('atomic-search-box');

        return new Promise((resolve) => {
            const interval = setInterval(() => {
                /*
                    The search box is fully loaded once the shadow root has children
                */
                if (this.atomicSearchBox.shadowRoot?.children.length) {
                    clearInterval(interval);
                    resolve();
                }
            }, 15);
        });
    }

    initEvents() {
        document.addEventListener('click', (event) => {
            if (this.atomicSuggestionsBox.offsetWidth) {
                return;
            }

            this.searchBox.classList.toggle('active', this.contains(event.target));
        });

        /*
            Watch the suggestions box's visibility, and if visible, make sure the search box is set as active. 
        */
        const observer = new MutationObserver((mutationList) => {
            const box = mutationList[0].target;

            if (box.offsetWidth) {
                this.searchBox.classList.add('active');
            }
        });

        observer.observe(this.atomicSuggestionsBox, { attributes: true });
    }

    render() {
        this.shadow.innerHTML = `
            <div class="search-box">
                <div class="search-box-wrapper">
                    <div class="search-box-border"></div>
                    <atomic-search-box></atomic-search-box>
                </div>
            </div>
        `;
    }
};